export default {"src":"/_next/static/media/assistant-nurse-with-medium-grey-text-box.0d16b7e1.svg","height":372,"width":260};